import Vue from 'vue';
import install from './install';

if (Vue) { install(Vue); }
export { default } from './insertable';
